import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
import { promiseTimeout } from '@vueuse/core';
import { BottomControlsButtons } from '~/core/components';
import { isValidEmail } from '~/core/utils/isValidEmail';
import CustomInfoAlert from '~/core/components/CustomInfoAlert/CustomInfoAlert.vue';
import useLocaleStore from '~/stores/useLocaleStore';
import { MailStatus } from '~/features/Profile/enums';
var emailRules = [function (v) {
  return !!v.trim().length || 'Укажите почту';
}, function (v) {
  return isValidEmail(v.trim()) || 'Неверный формат email';
}, function (v) {
  return v.trim().length < 100 || 'Должно быть не больше 100 символов';
}];
export default defineComponent({
  name: 'EnterMail',
  components: {
    CustomInfoAlert: CustomInfoAlert,
    BottomControlsButtons: BottomControlsButtons
  },
  props: {
    errorCode: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    locked: {
      type: Boolean,
      default: false
    },
    noBottomPanel: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Электронная почта'
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    withInfoAlert: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input', 'enter', 'send:mail', 'click:edit'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      expose = _ref.expose;
    var locale = useLocaleStore();
    var form = ref(null);
    var enterMailTextField = ref(null);
    var isFormCorrect = ref(false);
    var rules = computed(function () {
      return [].concat(emailRules, _toConsumableArray(props.rules), [function () {
        return props.errorCode !== MailStatus.Invalid || 'Неверный формат email';
      }, function () {
        return props.errorCode !== MailStatus.Unique || 'Эта почта привязана к другому пользователю';
      }, function () {
        return props.errorCode !== MailStatus.SameAsBefore || 'Это текущая почта. Укажите новую';
      }, function () {
        return props.errorCode !== MailStatus.DailyLimit || 'Отправить новый код можно через сутки';
      }, function () {
        return props.errorCode !== MailStatus.Confirmed || 'Данная почта уже подтверждена';
      }]);
    });
    watch(function () {
      return props.errorCode;
    }, function () {
      form.value.validate();
    });
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _enterMailTextField$v;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return promiseTimeout(250);
          case 2:
            (_enterMailTextField$v = enterMailTextField.value) === null || _enterMailTextField$v === void 0 ? void 0 : _enterMailTextField$v.focus();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    function sendCode() {
      form.value.validate();
      if (!isFormCorrect.value) {
        return;
      }
      emitInput(props.value.trim());
      emit('send:mail');
    }
    function emitInput(val) {
      emit('input', val);
    }
    function emitEnter(val) {
      sendCode();
      emit('enter', val);
    }
    function emitClickEdit() {
      emit('click:edit');
    }
    expose({
      isFormCorrect: isFormCorrect
    });
    return {
      locale: locale,
      enterMailTextField: enterMailTextField,
      form: form,
      isFormCorrect: isFormCorrect,
      inputRules: rules,
      sendCode: sendCode,
      emitInput: emitInput,
      emitEnter: emitEnter,
      emitClickEdit: emitClickEdit
    };
  }
});